export const CLOUDINARY_URL = process.env.REACT_APP_CLOUDINARY_URL;
export const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

// Unsigned upload: only the cloud's upload URL + preset are needed, no API secret involved.
export const uploadImageToCloudinary = async (base64Image) => {
  if (!CLOUDINARY_URL || !CLOUDINARY_UPLOAD_PRESET) {
    throw new Error('Image upload is not configured');
  }

  const res = await fetch(CLOUDINARY_URL, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      file: base64Image,
      upload_preset: CLOUDINARY_UPLOAD_PRESET,
    }),
  });

  const data = await res.json();

  if (!res.ok || !data?.url) {
    throw new Error(data?.error?.message || 'Image upload failed');
  }

  return data;
};
